import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CURRENCY_0 } from 'commons-vehicle/constants/currencyFormats.js';

import './PaymentDetailRebate.scss';

const PaymentDetailRebate = ({ amount, i18nKey, data, iconClass }) => {
    const currentClass = [iconClass, 'is-primary'];
    return (
        <div className="payment-rebate" {...data}>
            <div className="rebate-title">
                <icon className={currentClass.join(' ')} />
                <span>{LocaleService.t(i18nKey)}</span>
            </div>
            {amount && (
                <div className="rebate-amount is-bold">
                    <span>- {LocaleService.l(amount, CURRENCY_0)}</span>
                </div>
            )}
        </div>
    );
};

PaymentDetailRebate.defaultProps = {
    amount: null,
};

PaymentDetailRebate.propTypes = {
    amount: PropTypes.number,
    i18nKey: PropTypes.string.isRequired,
    data: PropTypes.shape({
        'sr-data': PropTypes.string.isRequired,
    }),
    iconClass: PropTypes.string.isRequired,
};

PaymentDetailRebate.displayName = 'PaymentDetailRebate';

export default PaymentDetailRebate;



// WEBPACK FOOTER //
// ./src/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.jsx